import styled from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

export const StyledGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxs}px;
  padding: ${({ theme }) => theme.spacing.xxs}px;
  background-color: ${({ theme }) => theme.colors.backgroundTertiary};
  border: 1px solid ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
`;

export const StyledSegment = styled.button.withConfig({ shouldForwardProp })<{ isActive: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xs}px;
  flex: 1;
  height: 30px;
  padding: 0 ${({ theme }) => theme.spacing.s}px;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.xs}px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.surfaceHover : 'transparent'};
  color: ${({ theme, isActive }) => (isActive ? theme.colors.textPrimary : theme.colors.textMuted)};

  &:hover {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;
